<template>
  <AuthMain>
    <v-form @keyup.native.enter="validate" ref="form" v-model="valid" lazy-validation> 
      <v-text-field
        prepend-icon="email"
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        prepend-icon="lock"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        :rules="passwordRules"
        :type="show ? 'text' : 'password'"
        name="password"
        label="Senha"
        hint="Pelo menos 6 caracteres"
        counter
        @click:append="show = !show"
      ></v-text-field>
    </v-form>
    <v-spacer></v-spacer>
    <v-btn
      rounded                  
      :disabled="!valid"
      color="primary"
      @click="validate"
      type="submit"
      large
      class="elevation"
      >
      Acessar
    </v-btn>    
    <!-- <v-btn
      rounded      
      color="default"
      @click="$router.push('/register')"
      type="submit"
      large
      class="elevation"
      >
      Criar conta
    </v-btn> -->
    <v-spacer></v-spacer>
    <a href="/forgot">Esqueci minha senha</a>
  </AuthMain>
</template>


<script>
  import AuthMain from './AuthMain.vue'
  import axios from 'axios';
  export default {
    components: {
      AuthMain
    },
    name: 'Login',
    data: () => ({      
      show: false,
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'E-mail deve ser válido'
      ],
      password: '',
      passwordRules:[
        v => !!v || 'Senha é obrigatório',
        v => (v && v.length >= 6) || 'A senha deve possuir no mínimo 6 caracteres'
      ],    
    }),
    mounted() {
      if (this.$route.params.email) {
        this.email = this.$route.params.email;
      }
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.login();
        }
      },
      reset () {
        this.$refs.form.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation();
      },
      login () {
        const {email, password} = this;
        this.$store.dispatch('login', {
          data: {
            email,
            password
          }
        });
      }
    }
  }
</script>

<style></style>